import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Does my athlete need beach volleyball experience?",
    a: "No. Camps are beginner-friendly and built for athletes trying beach for the first time, and clinics are designed to help indoor athletes transition their skills to the sand. No previous beach volleyball experience is required.",
  },
  {
    q: "What ages can participate?",
    a: "Camps are open to athletes ages 10–18. Clinics have separate Middle School and High School sessions.",
  },
  {
    q: "Does my athlete need a partner?",
    a: "No. Athletes do not need a partner to participate.",
  },
  {
    q: "Does my athlete have to stop playing indoor volleyball?",
    a: "No. Flexibility is one of the main reasons Beach Break exists. Athletes can experience beach while continuing to play indoor.",
  },
  {
    q: "When are clinics held?",
    a: "Clinics are 90-minute sessions held on Tuesdays and Thursdays from June–August 2027. Athletes can choose individual dates — no full-season commitment.",
  },
  {
    q: "Where will programs take place?",
    a: "Programs will be held in the Tampa, Florida area. Exact locations will be announced with Summer 2027 program details.",
  },
  {
    q: "When will Summer 2027 details be released?",
    a: "Registration details will be announced later. Joining the interest list is the best way to hear first.",
  },
];

export const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(-1);

  return (
    <section id="faq" className="py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-deep/70 flex items-center gap-2">
            <span className="w-8 h-px bg-sun" /> Questions, answered
          </p>
          <h2 className="mt-4 font-display uppercase text-deep leading-[0.95] text-[clamp(2.6rem,6vw,4.5rem)]">
            FAQ.
          </h2>
        </Reveal>

        <div className="mt-10 border-t border-deep/15">
          {FAQS.map((f, i) => {
            const open = openIdx === i;
            return (
              <Reveal key={i} delay={0.04 * i}>
                <div className="border-b border-deep/15">
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-6 py-5 text-left group"
                  >
                    <span className="font-bold text-deep text-sm md:text-base group-hover:text-sun transition-colors duration-200">
                      {f.q}
                    </span>
                    <motion.span
                      animate={{ rotate: open ? 45 : 0 }}
                      transition={{ duration: 0.25 }}
                      className={`shrink-0 w-8 h-8 rounded-full border flex items-center justify-center ${
                        open ? "bg-sun border-sun text-deep" : "border-deep/25 text-deep"
                      }`}
                    >
                      <Plus className="w-4 h-4" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {open && (
                      <motion.div
                        key="content"
                        data-testid={`faq-answer-${i}`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 pr-12 text-sm md:text-base text-deep-soft leading-relaxed">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
